<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Payroll Resurrect</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-timesheet-filter [filterFields]="fields"
                        (searchEvent)="onSearch($event)"></ppl-timesheet-filter>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Resurrect</strong> action, please select the applicable timesheet.</li>
                            <li>The <strong>Resurrect All</strong> action will update all timesheets that match the
                                search criteria OR all the selected timesheets.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(hasSearched) {
                    <ppl-list-table [actionButtons]="actionButtons" (actionInvoked)="gridAction($event)" [cols]="cols"
                        [customDataLoaded]="true" [data]="timesheets" [disableSearch]="true" [disableSort]="true"
                        [enableActions]="false" [from]="'timesheet'" [enablePageActions]="!isReadOnly" [gridTitle]="false"
                        [listButton]="isReadOnly ? [] : buttons" [loadPage]="true" [pagination]="true"
                        (rowDetailEventTs)="rowClicked($event)" (onPageLoad)="onPageLoad($event)" [showCustomSearch]="false"
                        [badgeColumns]="['Business Status']"
                        [timesheetFor]="'pendedTimesheet'" [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div class="filter-panel">
    <ng-template #timesheetResurrectDialog let-cancel="cancel">
        <ppl-timesheet-adjust-void-entry [timesheetData]="timesheetData" [searchParams]="appliedFilters"
            [actionData]="selectedAction" (timesheetAdjustedOrVoided)="timesheetResurrected($event)"
            [source]="'resurrect'"></ppl-timesheet-adjust-void-entry>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #deniedDialog let-cancel="cancel">
        <ppl-timesheet-staff-deniedreasons [deniedData]="deniedData"></ppl-timesheet-staff-deniedreasons>
    </ng-template>
</div>

